import React, { useEffect, useState } from 'react';
import { VertCarousel as AntCarousel, VertCarouselProps as AntCarouselProps } from '@vertem-core/vertice-ds';
import styled from 'styled-components';

interface CarouselProps extends AntCarouselProps {
  maxSlides?: number;
  slidesToShow?: number;
  children: React.ReactNode;
}

const StyledCarouselContainer = styled.div`
  .ant-carousel .slick-slide {
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
`;

const Carousel: React.FC<CarouselProps> = (props) => {
  const { maxSlides = 3, slidesToShow = 3, children, ...rest } = props;

  const [currentSlidesToShow, setCurrentSlidesToShow] = useState(slidesToShow);

  const updateSlidesToShow = () => {
    const width = window.innerWidth;

    const minSlideWidth = 300;

    const calculatedSlidesToShow = Math.max(1, Math.min(maxSlides, Math.floor(width / minSlideWidth)));

    setCurrentSlidesToShow(calculatedSlidesToShow);
  };

  useEffect(() => {
    updateSlidesToShow();
    window.addEventListener('resize', updateSlidesToShow);

    return () => window.removeEventListener('resize', updateSlidesToShow);
  }, [maxSlides]);

  return (
    <StyledCarouselContainer>
      <AntCarousel
      dots={false}
      arrows
      infinite={false}
      draggable
      responsive={[
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.1
          }
        },
        {
          breakpoint: 968,
          settings: {
            slidesToShow: 2.1
          }
        },
        {
          breakpoint: 9999,
          settings: {
            slidesToShow: 3.1
          }
        }
      ]}
       slidesToShow={currentSlidesToShow} slidesToScroll={currentSlidesToShow} {...rest}>
        {children}
      </AntCarousel>
    </StyledCarouselContainer>
  );
};

export default Carousel;
